import React from 'react';
import { AppBar, Box, makeStyles, Toolbar } from '@material-ui/core';

import Logo from '../../shared/assets/big-logo.png';
import smallLogo from '../../shared/assets/logo.png';
import { HeaderLogo } from './header-components/HeaderLogo';

import { ResponsiveLogo } from './header-components/ResponsiveLogo';
import { Navbar } from './Navbar';
import ResponsiveMenu from './header-components/HamburgerMenu';
import { useWindowScrollYIsGreaterThanEqual } from '../../shared/utils';

const useStyle = makeStyles(theme => ({
  navbarHeight: {
    [theme.breakpoints.down('sm')]: {
      height: 100,
    },
  },
  flexContainer: {
    backgroundColor: '#818293',
    display: 'flex',
    alignItems: 'start',
    justifyContent: 'space-between',
  },
  imgContainer: {
    width: '20%',
    paddingTop: 20,
    [theme.breakpoints.down('md')]: {
      padding: '20px 0 10px 20px',
      width: '15%',
    },
  },
  buttonsContainer: {
    // width: '70%',
    // display: 'flex',
    marginTop: '30px',
    // marginLeft: 300,
    // alignItems: 'flex-end',

    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  hamburgerContainer: {
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
    [theme.breakpoints.down('sm')]: {
      width: '80%',
      display: 'flex',
      height: '100%',
      justifyContent: 'flex-end',
      alignItems: 'flex-start',
      margin: '150px 100px 0 0',
    },
  },
}));

export const Header = () => {
  const classes = useStyle();

  return (
    <AppBar id="home" position="fixed" className={classes.navbarHeight}>
      <Toolbar className={classes.flexContainer}>
        <Box className={classes.imgContainer}>
          <HeaderLogo src={Logo} nomeimg="BG logo" />
          <ResponsiveLogo src={smallLogo} alt="BG logo" />
        </Box>
        <Box className={classes.buttonsContainer}>
          <Navbar />
        </Box>
        <Box className={classes.hamburgerContainer} />
      </Toolbar>
      <ResponsiveMenu />
    </AppBar>
  );
};
